<template>
  <el-dialog
      :visible.sync="dialogVisible"
      title="装箱单打印"
      width="800px">
    <div style="border-bottom:1px solid #000;font-weight:700">打印设置</div>
    <el-form :inline="true" label-width="80px">
      <el-form-item label="LOGO">
        <el-checkbox v-model="logoVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="客户编号">
        <el-checkbox v-model="customerNoVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="订单号">
        <el-checkbox v-model="billNoVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="备注信息">
        <el-checkbox v-model="noteVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="制造商">
        <el-checkbox v-model="supplierVisible" label="打印"/>
      </el-form-item>
    </el-form>
    <div style="border-bottom:1px solid #000;font-weight:700">打印模板</div>
    <div style="padding: 0">
      <table id="printLabel">
        <tr>
          <td v-if="logoVisible" colspan="2">
            <!--            <img width="220" height="50" src="../../../../public/img/se/print_logo.png">-->
            <img width="210" height="45" :src="logoSrc">
          </td>
          <td v-else colspan="4" class="labelTitle">
            <div style="text-align: center;">装箱单</div>
          </td>
          <td v-if="logoVisible" colspan="2" class="labelTitle">
            <div style="text-align: left;">装箱单</div>
          </td>
        </tr>
        <tr>
          <td v-if="customerNoVisible" class="label">客户编码</td>
          <td v-else/>
          <td v-if="customerNoVisible && !isPrint">
            <el-input v-model="labelData.customerNo" placeholder="请输入客户编码"/>
          </td>
          <td v-else-if="isPrint && customerNoVisible" class="content">{{labelData.customerNo}}</td>
          <td v-else/>
          <td v-if="billNoVisible" class="label">订单号</td>
          <td v-else/>
          <td v-if="billNoVisible && !isPrint">
            <el-input v-model="labelData.orderNo" placeholder="请输入订单号"/>
          </td>
          <td v-else-if="isPrint && billNoVisible" class="content">{{labelData.billNo}}</td>
          <td v-else/>
        </tr>
        <tr>
          <td class="label">产品品名</td>
          <td v-if="!isPrint">
            <el-input v-model="labelData.materialName" placeholder="请输入产品品名"/>
          </td>
          <td v-else class="content">{{labelData.materialName}}</td>
          <td class="label">内装数量</td>
          <td v-if="!isPrint">
            <el-input v-model="labelData.quantity" placeholder="请输入内装数量"/>
          </td>
          <td v-else style="font-size: 22px;font-weight: bold;">{{labelData.quantity}}</td>
        </tr>
        <tr>
          <td class="label">规格型号</td>
          <td v-if="!isPrint">
            <el-input v-model="labelData.specification" placeholder="请输入规格型号"/>
          </td>
          <td v-else class="content">{{labelData.specification}}</td>
          <td class="label">箱数</td>
          <td v-if="!isPrint">
            <el-input v-model="labelData.amount" placeholder="请输入箱数"/>
          </td>
          <td v-else style="font-size: 22px;font-weight: bold;">{{labelData.amount}}</td>
        </tr>
        <tr>
          <td v-if="noteVisible && !isPrint" class="label" colspan="2">
            <el-input v-model="labelData.note" type="textarea" autosize placeholder="请输入订单备注"/>
          </td>
          <td v-else-if="isPrint && noteVisible" class="content" colspan="2">{{labelData.note}}</td>
          <td v-else colspan="2"/>
          <td class="label">装箱日期</td>
          <td v-if="!isPrint">
            <el-date-picker
                v-model="labelData.date"
                type="date"
                value-format="yyyy-MM-dd"/>
          </td>
          <td v-else class="content">{{labelData.date}}</td>
        </tr>
        <tr>
          <td v-if="supplierVisible" class="label">制造商</td>
          <td v-else/>
          <td v-if="supplierVisible && !isPrint">
            <el-input v-model="labelData.manufactor" placeholder="请输入制造商" clearable/>
          </td>
          <td v-else-if="isPrint && supplierVisible" colspan="2" class="content">{{labelData.manufactor}}</td>
          <td v-else/>
          <td colspan="2" rowspan="2">
            <div id="qrCode" align="center"/>
          </td>
        </tr>
        <tr>
          <td v-if="supplierVisible" class="label">联系电话</td>
          <td v-else/>
          <td v-if="supplierVisible && !isPrint">
            <el-input v-model="labelData.telephone" placeholder="请输入联系电话" clearable/>
          </td>
          <td v-else-if="isPrint && supplierVisible" colspan="2" class="content">{{labelData.telephone}}</td>
          <td v-else/>
        </tr>
      </table>
    </div>
    <div slot="footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button @click="editDialog">编辑</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";

  export default {
    data() {
      return {
        logoSrc: "",
        dialogVisible: false,
        logoVisible: true,
        billNoVisible: true,
        customerNoVisible: true,
        noteVisible: true,
        supplierVisible: true,
        isPrint: false,
        labelData: {
          customerNo: "",
          billNo: "",
          orderNo:"",
          materialName: "",
          quantity: "",
          specification: "",
          amount: "",
          note: "",
          date: this.$moment().format("yyyy-MM-DD"),
          manufactor: "上海鸿康电器有限公司",
          telephone: "021-37701209",
          pkid: 0,
        },
        printOption: {
          id: "printLabel",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
            this.isPrint = false;
          },
        },
      };
    },
    methods: {
      open(row) {
        this.logoSrc = "../../../../img/se/print_logo.png";
        this.dialogVisible = true;
        this.labelData = row;
        // const item = row[0].billNo;
        this.$nextTick(() => {
          document.getElementById("qrCode").innerHTML = "";
          this.bindQRCode(row.billNo);
        });
      },

      closeDialog() {
        this.dialogVisible = false;
      },
      editDialog() {
        this.isPrint = false;
      },
      bindQRCode(row) {
        let text = row;
        new QRCode(document.getElementById("qrCode"), {
          text: text,
          width: 80,
          height: 80,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      print() {
        this.isPrint = true;
        this.$nextTick(() => {
          // document.body.innerHTML = document.getElementById("printLabel").parentNode.innerHTML;
          // window.print();
          // window.location.reload();

          if (this.labelData.pkid && this.labelData.pkid != 0) {
            this.$http.get("basic", `taskDispatchBills/updatePrintBox/${this.labelData.pkid}`).then(() => {
            });
          }
          return false;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
@media print {
  table {
    width: 120mm;
    height: 90mm;
  }
  .hkIcon {
    width: 35mm;
    padding: 0;
  }
  .labelTitle {
    font-size: 16px;
    font-weight: 700;
    color: #000;
    text-align: center;
  }
  table .label {
    width: 20%;
    padding-left: 0;
  }
  table .content {
    //width: 40%;
    font-size: 18px;
    padding: 0;
  }
  //body {
  //  font-size: 18px;
  //  color: #000;
  //}
}

//table td {
//  padding: 2px;
//}

.labelTitle {
  font-size: 32px;
  font-weight: 700;
  color: #000;
  text-align: left;
}

.label {
  //width: 20%;
  font-size: 16px;
}

//.inputClass {
//  font-size: 18px;
//  padding: 0;
//}
</style>